import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Theme, withTheme } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import theme from '../theme';

type Props = {
  children: React.ReactNode;
  theme: Theme;
};

function ContextProvider({ children, theme: muiTheme }: Props) {
  return (
    <ThemeProvider theme={{ ...theme, mui: muiTheme }}>
      <MuiThemeProvider theme={createMuiTheme(theme.mui)}>
        <BrowserRouter>
          <>{children}</>
        </BrowserRouter>
      </MuiThemeProvider>
    </ThemeProvider>
  );
}

export default withTheme()(ContextProvider);
